// extracted by mini-css-extract-plugin
module.exports = {"button":"TabsLoadMore_button__qx5Lp","buttonLabel":"TabsLoadMore_buttonLabel__hrJZJ"};